// extracted by mini-css-extract-plugin
export default {"root":"CardListCountries-module__[local]___IGnNE","card":"CardListCountries-module__[local]___LlkK4","title":"CardListCountries-module__[local]___1qSdx"};